import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      examLibInfo: {},
      practiceDialogVisible: false,
      selectedLibIdx: 0,
      practiceType: 0 // 0：全部；1：未做的题；2：错题；3：已答的题
    };
  },
  created: function() {
    // 加载题库信息
    this.loadExamLib();
  },
  methods: {
    async loadExamLib() {
      // 加载题库
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest("/app/answer/total", "get", null);
      loadingInstance.close();
      if (res !== null && res !== undefined && res.code === 200) {
        this.examLibInfo = res.data;
      }
    },
    showPracticeDialog(idx) {
      this.selectedLibIdx = idx;
      this.practiceDialogVisible = true;
    },
    go2PracticeExam() {
      // 根据选择的提醒，看有多少可以做的题目
      if (this.practiceType === 0) {
        if (
          this.examLibInfo.examLibs[this.selectedLibIdx].totalQuestions === 0
        ) {
          this.$message.error("题目为空，无法做题");
          return;
        }
      } else if (this.practiceType === 1) {
        if (
          this.examLibInfo.examLibs[this.selectedLibIdx].answerQuestions ===
          this.examLibInfo.examLibs[this.selectedLibIdx].totalQuestions
        ) {
          this.$message.error("题目为空，无法做题");
          return;
        }
      } else if (this.practiceType === 2) {
        if (this.examLibInfo.examLibs[this.selectedLibIdx].accuracy === 100) {
          this.$message.error("题目为空，无法做题");
          return;
        }
      } else if (this.practiceType === 3) {
        if (
          this.examLibInfo.examLibs[this.selectedLibIdx].answerQuestions === 0
        ) {
          this.$message.error("题目为空，无法做题");
          return;
        }
      } else {
        this.$message.error("参数异常，无法做题");
        return;
      }
      // 跳转到做题界面
      this.practiceDialogVisible = false;
      this.$router.push({
        path: "/practiceLibExam",
        query: {
          libId: this.examLibInfo.examLibs[this.selectedLibIdx].lib_id,
          answerType: this.practiceType
        }
      });
    }
  }
};
